import { hiIN } from './hi'
import { idID, idID_nonRedundent } from './id'
import { kmKH } from './km'
import { msMY } from './ms'
import { spotlightThTH, th, thTH_nonRedundent } from './th'
import { tlPH } from './tl-ph'
import { spotlightViVN, viVN } from './vi'
import { zhTW } from './zh'

export const getLocaleAdMappingFromSlug = (locale: string, slug: string) => {
  const cleanedSlug = slug.split('/').filter(Boolean).join('/')
  let processingSlug = cleanedSlug
  while (true) {
    let found = null
    switch (locale) {
      case 'km-KH':
        found = kmKH[processingSlug]
        break
      case 'hi-IN':
        found = hiIN[processingSlug]
        break
      case 'th-TH':
        found = th[processingSlug]
        break
      case 'id-ID':
        found = idID[processingSlug]
        break
      case 'ms-MY':
        found = msMY[processingSlug]
        break
      case 'vi-VN':
        found = viVN[processingSlug]
        break
      case 'zh-TW':
        found = zhTW[processingSlug]
        break
      case 'tl-PH':
        found = tlPH[processingSlug]
        break
    }
    if (found) return found
    // remove last slash section
    if (processingSlug.indexOf('/') > -1) {
      processingSlug = processingSlug.substring(
        0,
        processingSlug.lastIndexOf('/'),
      )
    } else {
      return null
    }
  }
}
export const getSpotlightLocaleAdMappingFromSlug = (
  locale: string,
  spotlightSlug: string,
) => {
  const cleanedSlug = spotlightSlug.split('/').filter(Boolean).join('/')
  let processingSlug = cleanedSlug
  while (true) {
    let found = null
    switch (locale) {
      case 'vi-VN':
        found = spotlightViVN[cleanedSlug]
        break
      case 'th-TH':
        found = spotlightThTH[cleanedSlug]
        break
    }
    if (found) return found
    // remove last slash section
    if (processingSlug.indexOf('/') > -1) {
      processingSlug = processingSlug.substring(
        0,
        processingSlug.lastIndexOf('/'),
      )
    } else {
      return null
    }
  }
}
export const getLocaleAdMappingFromSlugNonRedundant = (
  locale: string,
  slug: string,
) => {
  const cleanedSlug = slug.split('/').filter(Boolean).join('/')
  let processingSlug = cleanedSlug
  while (true) {
    let found = null
    switch (locale) {
      case 'id-ID':
        found = idID_nonRedundent[cleanedSlug]
        break
      case 'th-TH':
        found = thTH_nonRedundent[cleanedSlug]
        break
    }
    if (found) return found
    // remove last slash section
    if (processingSlug.indexOf('/') > -1) {
      processingSlug = processingSlug.substring(
        0,
        processingSlug.lastIndexOf('/'),
      )
    } else {
      return null
    }
  }
}
